/* Steffie's Fit Finder — account sync via the Customer Account API (public client + PKCE).
   READS are handled server-side in Liquid (customer.metafields). This file handles the
   WRITE: a one-click "Sync to my account" that full-redirects to authorize (prompt=none when
   already signed in → seamless), exchanges the code with PKCE, and writes custom.fit_profile. */
(function(){
  var root = document.getElementById('steffie-fit');
  if (!root) return;

  var CLIENT_ID = root.getAttribute('data-caa-client-id');
  var REDIRECT  = root.getAttribute('data-caa-redirect');
  var LOGGED_IN = root.getAttribute('data-logged-in') === 'true';
  if (!CLIENT_ID || !REDIRECT) return; // not configured → browser-only

  var AUTHZ = 'https://account.steffies.com/authentication/oauth/authorize';
  var TOKEN = 'https://account.steffies.com/authentication/oauth/token';
  var GQL   = 'https://account.steffies.com/customer/api/2026-04/graphql';
  var SCOPE = 'openid email customer-account-api:full';

  function b64url(s){ return btoa(s).replace(/\+/g,'-').replace(/\//g,'_').replace(/=/g,''); }
  function rand(){ var a=new Uint8Array(32); crypto.getRandomValues(a); return b64url(String.fromCharCode.apply(null,a)); }
  function challenge(v){ return crypto.subtle.digest('SHA-256', new TextEncoder().encode(v)).then(function(d){ return b64url(String.fromCharCode.apply(null,new Uint8Array(d))); }); }

  function exchange(code, verifier){
    var b=new URLSearchParams();
    b.set('grant_type','authorization_code'); b.set('client_id',CLIENT_ID);
    b.set('redirect_uri',REDIRECT); b.set('code',code); b.set('code_verifier',verifier);
    return fetch(TOKEN,{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:b})
      .then(function(r){ return r.json(); }).then(function(j){ return j.access_token || null; });
  }
  function gql(token, query, variables){
    return fetch(GQL,{method:'POST',headers:{'Content-Type':'application/json','Authorization':token},body:JSON.stringify({query:query,variables:variables||{}})}).then(function(r){ return r.json(); });
  }
  function getCustomerId(token){
    return gql(token,'{ customer { id } }').then(function(r){ return (r&&r.data&&r.data.customer)?r.data.customer.id:null; });
  }
  function writeProfile(token, id, profile){
    var m='mutation($mf:[MetafieldsSetInput!]!){ metafieldsSet(metafields:$mf){ userErrors{ message } } }';
    return gql(token,m,{ mf:[{ ownerId:id, namespace:'custom', key:'fit_profile', type:'json', value:JSON.stringify(profile) }] });
  }
  function flag(msg){ var s=document.getElementById('steffie-fit-saved'); if(s) s.textContent=msg; }

  // Handle the OAuth callback on page load: ?code + matching PKCE state → write the pending profile.
  (function handleCallback(){
    var p=new URLSearchParams(location.search);
    var code=p.get('code'), state=p.get('state');
    if (!code || !state) return;
    var verifier=sessionStorage.getItem('sfit_v_'+state);
    if (!verifier) return;
    sessionStorage.removeItem('sfit_v_'+state);
    var pending=null; try{ pending=JSON.parse(sessionStorage.getItem('sfit_pending')||'null'); }catch(e){}
    sessionStorage.removeItem('sfit_pending');
    history.replaceState({}, document.title, location.pathname);
    exchange(code, verifier).then(function(token){
      if (!token || !pending) return;
      getCustomerId(token).then(function(id){
        if (!id) return;
        writeProfile(token, id, pending).then(function(res){
          var ok = res && res.data && res.data.metafieldsSet && (!res.data.metafieldsSet.userErrors || !res.data.metafieldsSet.userErrors.length);
          flag(ok ? "Synced to your account — your size now follows you on every device." : "Saved to this device.");
        });
      });
    });
  })();

  // Public: stash the profile and redirect to authorize (seamless when already signed in).
  window.SteffieFitAccount = {
    enabled: true,
    loggedIn: LOGGED_IN,
    connect: function(profile){
      var verifier=rand(); var state=rand();
      challenge(verifier).then(function(ch){
        sessionStorage.setItem('sfit_v_'+state, verifier);
        try{ sessionStorage.setItem('sfit_pending', JSON.stringify(profile)); }catch(e){}
        var u=new URL(AUTHZ);
        u.searchParams.set('scope',SCOPE);
        u.searchParams.set('client_id',CLIENT_ID);
        u.searchParams.set('response_type','code');
        u.searchParams.set('redirect_uri',REDIRECT);
        u.searchParams.set('state',state);
        u.searchParams.set('code_challenge',ch);
        u.searchParams.set('code_challenge_method','S256');
        if (LOGGED_IN) u.searchParams.set('prompt','none');
        window.location.href = u.toString();
      });
    }
  };
})();
